import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api, type WorkOrder } from '../../lib/api'
import { Loading, Alert } from '../../components/ui'
import WorkOrderDoc from './WorkOrderDoc'
import { IconButton } from '../../components/IconButton'
import { downloadElementAsPdf, pdfFilename, whenDocReady } from '../../lib/pdfExport'

export default function WorkOrderPrint() {
  const { id } = useParams()
  const [w, setW] = useState<WorkOrder | null>(null)
  const [error, setError] = useState('')
  const docRef = useRef<HTMLDivElement>(null)
  const [pdfBusy, setPdfBusy] = useState(false)
  const [pdfError, setPdfError] = useState('')

  useEffect(() => {
    api.get<WorkOrder>(`/work-orders/${id}`).then(setW).catch((e) => setError(e.message))
  }, [id])

  const printWhenReady = async () => {
    await whenDocReady()
    window.print()
  }

  /* 下載 PDF 跟「列印」分開，理由同驗收單：固定參數輸出，寄出去的版本才會一致 */
  const savePdf = async () => {
    if (!docRef.current || !w) return
    setPdfError(''); setPdfBusy(true)
    try {
      await downloadElementAsPdf(docRef.current, pdfFilename('發包單', w.code, w.writer_name))
    } catch (e: any) {
      setPdfError(`產生 PDF 失敗：${e?.message || e}`)
    } finally {
      setPdfBusy(false)
    }
  }

  if (error) return <Alert kind="error">{error}</Alert>
  if (!w) return <Loading />

  return (
    <>
      <div className="page-head no-print">
        <h2>發包單列印預覽</h2>
        <div className="spacer" />
        {/* 順序與驗收單一致：返回、編輯、下載、列印 */}
        <div className="btn-row">
          <IconButton icon="back" to="/work-orders" tip="返回：回到發包單清單" />
          <IconButton icon="edit" to={`/work-orders/${w.id}`} tip="編輯：修改這張發包單的內容" />
          <IconButton icon="download" onClick={savePdf} disabled={pdfBusy}
            tip={pdfBusy ? '正在產生 PDF…' : '下載 PDF：直接存成檔案，版面固定，適合寄給寫手'} />
          <IconButton icon="print" className="primary" onClick={printWhenReady} disabled={pdfBusy}
            tip="列印：開啟列印對話框，送到印表機" />
        </div>
      </div>
      {pdfError && <div className="no-print"><Alert kind="error">{pdfError}</Alert></div>}

      <WorkOrderDoc w={w} docRef={docRef} />
    </>
  )
}
